import { FC } from "react";
import { Autocomplete, TextField } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";

type JobSelectProps = {
  handleJobTypeChange: any;
  selectedJobType: any;
  jobTypes: any;
  className?: string;
  disabled: boolean;
  errors: any
};

const JobTypeSelect: FC<JobSelectProps> = ({
  handleJobTypeChange,
  selectedJobType,
  jobTypes,
  className,
  disabled,
  errors,
}) => {

  return (
    <Autocomplete
      id="idJobType"
      className={`my-2 ${className || ''}`}
      options={jobTypes || []}
      getOptionLabel={(option) => intl.get(option.label)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={
        !disabled && jobTypes && selectedJobType != null
          ? jobTypes.find((jobType) => jobType.id === selectedJobType) || null
          : null
      }
      onChange={(event, newValue) => handleJobTypeChange(newValue)}
      disabled={disabled}
      loading={jobTypes == null}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={`${intl.get('jobProject.body.jobType')}`}
          placeholder={intl.get("jobTypeSelect.placeholder")}
          error={!!errors.idJobType}
          helperText={errors.idJobType}
          size="small"
        />
      )}
    />
  );
};

export default JobTypeSelect;
